export const mapStateToProps = (state) => ({
  scoring: state.settlements.scoring,
  selectedGame: state.settlements.selectedGame,
});
